<template>
    <div>
      <p>Счётчик: {{ count }}</p>
      <p>Таймер: {{ timer }} мс</p>
  
      <button @click="startTimer">▶️ Запустить таймер</button>
      <button @click="increaseTimer">➕ Увеличить таймер</button>
      <button @click="decreaseTimer">➖ Уменьшить таймер</button>
      <button @click="decreaseTimerLoop">⏬ Уменьшать таймер</button>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        count: 0, // Текущий прогресс
        timer: 20000, // Длительность в мс
        intervalId: null, // ID setInterval
        decreaseInterval: null, // ID setInterval для уменьшения таймера
        startTime: null, // Время старта
        elapsedTime: 0, // Сколько уже прошло времени
        isRunning: false, // Флаг для отслеживания состояния таймера
      };
    },
    watch: {
      timer(newVal, oldVal) {
        if (this.isRunning) {
          this.restartCounter();
        }
      },
    },
    methods: {
      startCounter(target) {
        if (this.intervalId) clearInterval(this.intervalId); // Остановить предыдущий таймер
  
        this.startTime = performance.now() - this.elapsedTime; // Коррекция времени старта
        const stepTime = 16;
        this.isRunning = true; // Устанавливаем флаг, что таймер работает
  
        this.intervalId = setInterval(() => {
          const now = performance.now();
          this.elapsedTime = now - this.startTime;
  
          let progress = (this.elapsedTime / this.timer) * target;
          if (progress >= target) {
            progress = target;
            clearInterval(this.intervalId);
            this.intervalId = null;
            this.isRunning = false; // Сбрасываем флаг, когда таймер завершился
          }
          this.count = Math.floor(progress);
        }, stepTime);
      },
  
      startTimer() {
        if (!this.isRunning) {
          this.startCounter(100);
        }
      },
  
      restartCounter() {
        this.startTime = performance.now() - this.elapsedTime;
      },
  
      increaseTimer() {
        if (this.decreaseInterval) {
          clearInterval(this.decreaseInterval); // Останавливаем уменьшение
          this.decreaseInterval = null;
        }
        this.timer += 5000;
      },
  
      decreaseTimer() {
        if (this.timer > 1000 && this.count !== 100) {
          this.timer -= 5000;
        }
      },
  
      decreaseTimerLoop() {
        if (this.decreaseInterval) return; // Если уже запущен, не дублируем
  
        this.decreaseInterval = setInterval(() => {
          if (this.count !== 100 && this.timer > 1000) {
            this.timer -= 5000;
          } else {
            clearInterval(this.decreaseInterval); // Останавливаем, если count = 100
            this.decreaseInterval = null;
          }
        }, 1000);
      },
    },
  };
  </script>
  